import { render, staticRenderFns } from "./PublicPaymentForm.vue?vue&type=template&id=68a6fbd8"
import script from "./PublicPaymentForm.vue?vue&type=script&lang=js"
export * from "./PublicPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports